// customer服务器，文档参考：https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20618658
export const HOST = ['https://test-customer.ihuhoo.com', 'https://customer.tradeup.com'];
export const API = {
    host: '',
    fields: {
        cnArea: '/api/v1/account/field/area', // 国内省市区
        countryUS: '/api/v1/account/field/country_us',
        stateUS: '/api/v1/account/field/state_us',
        careerUS: '/api/v1/account/field/business_career_us',
        companyUS: '/api/v1/account/field/et_company',
        proofUs: '/api/v1/account/field/proof_us',
        country_us_group: '/api/v1/account/field/country_us_group',
        infos: '/api/v1/account/infos'
    },
    getRates: '/support/api/v1/pay/rate', // pricing 页面
    proofUrl: ':path',
    // https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get-api-v3-individual-account-process
    status: '/api/v3/individual/account/process', // 查询开户进度

    /**
     * 协议和下载相关 https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=45843480 @郭江帅
     */
    agreements: '/support/api/v1/individual/agreements/open_account', // 获取协议列表
    // https://apidocs.tigerfintech.com/repository/23/api/master/Internal%20API.json#/operations/get--internal-api-v1-agreement-{link_code1}
    agreement: '/support/api/v1/agreement/:id', // 用户协议
    statement: '/support/api/v1/individual/statement/:id', // 服务和隐私声明
    agreementDownload: '/support/api/v1/individual/agreements/open_account/download', // help 页面协议打包下载 @郭江帅  https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=23594288
    appLink: '/support/api/v1/download/app', // app download link
    getBankCountry: '/api/v1/account/field/country_bank', // 获取出金国家

    /**
     * ACH 出入金
     * 接口文档：https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=25988579#%E9%93%B6%E8%A1%8C%E5%8D%A1%E6%93%8D%E4%BD%9C-%E6%9F%A5%E8%AF%A2v2
     *
     */
    sendNotification: '/fund/api/v1/individual/deposit/wire', // 存款通知
    getGuide: '/fund/api/v1/individual/withdraw/guide', // 出金指引
    getProfile: '/api/v1/individual/customer/profile', // 获取客户基本信息
    getAccountInfo: '/api/v1/individual/account/info', // 获取客户的账户信息
    /**
     * 可靠联系人
     */
    // https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get--api-v1-individual_us-customer-contacts
    getTrustedPerson: '/api/v1/individual/customer/contacts', // 可靠联系人
    deleteTrustedPerson: '/api/v1/individual/customer/contacts/:id', // 删除可靠联系人

    /**
     * JWT 客服
     */
    getWebWidget: '/support/api/v1/chat/jwt', // 获取JWT_TOKEN_ENDPOINT

    /**
     * IB password
     */
    ibPasswrod: '/api/v1/account/retrieve/ib_password', // ib 账户密码 @黄翀 7.8 修改为 customer

    /**
     * 税表信息
     * @ 郭江帅
     */
    tax: {
        getTaxes: '/api/v1/individual/customer/taxes', // 查询某年税表信息(某年的当前版)
        getHistoryTaxes: '/api/v1/individual/customer/taxes/archive', // 查询历史税表
        downloadTaxFile: '/file/api/v1/file/retrieve:file_uri' // 下载税表文件
    },

    /**
     * 转股接入 @zaichuipan https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=27820833
     */
    transfer: {
        // 这是一个分页接口: https://apidocs.tigerfintech.com/repository/23/api/master/APP-Web.json#/operations/get--api-v1-broker-config-list
        transferBrokerSearch: '/support/api/v1/broker/config/list', // 券商搜索
        // https://tigertech.feishu.cn/wiki/ROHPwAR48irCxQkiaGCcqGCdnBf @赵磊
        transferSave: '/api/fund/biz/transfer/save', // 保存转股纪录 post
        // https://tigertech.feishu.cn/docx/YzBcd1mA3oL5NNxJxszckLsxn5b
        fundSearch: '/api/fund/biz/transfer/mutual_funds/search', // Mutual Funds 模糊搜索
        transferSearch: '/api/fund/biz/transfer/:id', //  根据id查询 get
        updateTransfer: '/api/fund/biz/transfer/:id', // 更新转股信息 post
        // https://tigertech.feishu.cn/wiki/ROHPwAR48irCxQkiaGCcqGCdnBf @赵磊
        transferQuery: '/api/fund/biz/transfer/query', // 个人转股记录查询 get
        transferWithdraw: '/api/fund/biz/transfer/withdraw', // 个人转股撤回 post
        transferInfo: '/api/v1/position/transfer/info' // 个人信息
    },

    // https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=60920202
    getHKDVan: '/api/v1/account/assign/van', // 生成VAN账号
    // close: '/api/v1/account/close', // GET 表示查询关闭帐户状态 POST 表示提交关闭帐户申请/撤销关闭帐户申请
    /**
     * 关闭帐户
     * https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=29559059 @周榆宏
     */
    close: {
        // 获取帐户关闭状态 PENDING, SUCCESS, REJECTED, REVOKING, REVOKE 如果用户未提交申请为null （PENDING | REVOKING）表示不能提交关闭帐户申请
        getCloseStatus: '/api/v1/individual/application/process',
        // 检查是否可以关户，并返回不能提交的理由
        checkClose: '/api/v1/account/close/check',
        // 提交关户申请
        submitClose: '/api/v1/individual/application/close',
        // 撤销关户申请
        deleteSubmitClose: '/api/v1/individual/application/close'
    },

    web: {
        // 针对个人中心提供的专门接口
        // https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get--api-v1-web-account-info
        accountInfo: '/api/v1/web/account/info'
    },

    uploadPic: '/file/api/v1/file/upload/:bucketName',
    // 获取文件: https://apidocs.tigerfintech.com/repository/13/api/master/reference/app-web.json#/operations/get--api-v1-file-retrieve%7Bfile_uri%7D
    getFile: '/file/api/v1/file/retrieve:file',
    /**
     * https://tigertech.feishu.cn/docx/TkwVdyGBAoEUklx27GvcFZHTn4e
     * @RD dingyaguang
     */
    checkClose: '/api/v1/account/close/check',
    submitClose: '/api/v1/individual/application/close',
    account: {
        // 目前融合了证件、地址、工作信息和资产的修改状态
        // https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get--api-v1-web-customer-info @sunzhenzhao
        modifyStatus: '/api/v1/web/customer/info'
    },
    customerInfo: '/api/v1/individual/customer/info' // 客户开户资料
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API.customer?.TBUS;

    cfg && HOST.fill(cfg);
}
